import { render, staticRenderFns } from "./Ruangan.vue?vue&type=template&id=739d4a58"
import script from "./Ruangan.vue?vue&type=script&lang=js"
export * from "./Ruangan.vue?vue&type=script&lang=js"
import style0 from "./Ruangan.vue?vue&type=style&index=0&id=739d4a58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports